import React, { useContext, useEffect, useState, useRef } from "react";
import "./contacts.scss";
import { AppContext } from "../../services/translationContext";
import { Buffer } from 'buffer';
import Box from '@mui/material/Box';
import CircularProgress, {circularProgressClasses} from '@mui/material/CircularProgress';
import SeoHelmet from "../../components/SeoHelmet";
import { useParams } from "react-router-dom";

const appOwner = process.env.REACT_APP_OWNER;
const api = process.env.REACT_APP_URL_API;
const turnstile_key = process.env.REACT_APP_TURNSTILE;

export const Contacts = () => {
   const { lang } = useParams();
  const { services: { TranslationsService } } = useContext(AppContext);
  document.title = `${TranslationsService.labels(`menu.contact-us.label`)} | ${TranslationsService.getMainInfoCompany('name')}`;
  const [showToast, setShowToast] = useState('hide');
  const [isLoading, setIsLoading] = useState(false);

  const widgetRef = useRef(null);
  const widgetId = useRef(null);

  const offices = TranslationsService.getGlobalValue('offices') || [];
  const pageTitle = `${TranslationsService.labels(`menu.contact-us.label`)} | ${TranslationsService.getMainInfoCompany('name')}`;
  const contactsUrl = `https://www.sydea.com/${lang}/contacts`;

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `https://www.sydea.com/${lang}` },
      { "@type": "ListItem", position: 2, name: TranslationsService.labels(`menu.contact-us.label`), item: contactsUrl }
    ]
  };

  const contactPageSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: pageTitle,
    url: contactsUrl
  };

  const localBusinessSchemas = offices.map((office) => ({
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: `Sydea - ${office.city}`,
    address: {
      "@type": "PostalAddress",
      streetAddress: office.street,
      addressLocality: office.city,
      addressRegion: office.region || undefined,
      postalCode: office.postal_code || undefined,
      addressCountry: office.country_code
    },
    telephone: office.phone_number,
    url: "https://www.sydea.com",
    parentOrganization: {
      "@type": "Organization",
      name: "Sydea",
      url: "https://www.sydea.com"
    },
    ...(office.google_maps ? { hasMap: office.google_maps } : {})
  }));

  const schema = [contactPageSchema, breadcrumbSchema, ...localBusinessSchemas];

  useEffect(() => {
    const renderWidget = () => {
      if (!window.turnstile || !widgetRef.current) {
        setTimeout(renderWidget, 100);
        return;
      }
      if (widgetId.current !== null) return;
      widgetId.current = window.turnstile.render(widgetRef.current, {
        sitekey: turnstile_key,
      });
    };
    renderWidget();
  }, []);

  const formatTextWithBr = (text) => {
    let textArea = '';
    text.split('\n').map((line, index) => (
      textArea +=`${line}<br />`
    ));
    return textArea;
  };

  const initialFormData = {
    name: '',
    mailSubject: '',
    email: '',
    bodyMail: '',
    isChecked: false,
  };

  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: newValue,
    }));
  };

  const handleSubmit = (event) => {
    const mailForm = TranslationsService.getMailTemaplateContact();
    event.preventDefault();
    const { name, mailSubject, email, bodyMail } = formData;

    let body_mail = mailForm.template;
    const variables = { name, mailSubject, email, bodyMail };

    Object.keys(variables).forEach(key => {
      const regex = new RegExp('\\${' + key + '}', 'g');
      if (body_mail.indexOf('${' + key + '}') !== -1) {
        if (key === 'bodyMail') {
          const formattedValue = formatTextWithBr(variables[key]);
          body_mail = body_mail.replace(regex, formattedValue);
        } else {
          body_mail = body_mail.replace(regex, variables[key]);
        }
      } else {
        console.error(`La stringa iniziale non contiene ${key}`);
      }
    });

    let buffer = Buffer.from(body_mail);
    let base64String = buffer.toString('base64');

    let _body = {
      to: [email],
      subject: `Confirmation of Request Receipt - ${mailSubject}`,
      body: base64String,
    };

    setIsLoading(true);
    setTimeout(() => {
      setFormData(initialFormData);
      setShowToast('show');
      setTimeout(() => {
        setShowToast('hide');
        setIsLoading(false);
      }, 2000);
    }, 1000);

    const turnstileToken = window.turnstile.getResponse(widgetId.current);
    if (!turnstileToken) {
      alert("Complete Human Verification before continue");
      return;
    }

    const requestOptions = {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json', 
        'x-origin-verify': 'BB6a2U8jgygBYCqo8yfW8HT9P8EKafR2',
        'x-turnstile-response': turnstileToken,
      },
      body: JSON.stringify(_body)
    };

    fetch(`${api}/mail`, requestOptions).then((response) => {
      // setFormData(initialFormData);
      // setShowToast('show');
      // setTimeout(() => {
      //   setShowToast('hide');
      // }, 3000);
    })
    .catch((error) => {
      setFormData(initialFormData);
    });
  };

  function CustomCircularProgress(props) {
    return (
      <Box sx={{ position: 'relative' }}>
        <CircularProgress
          variant="determinate"
          sx={(theme) => ({
            color: theme.palette.grey[800],
            ...theme.applyStyles('dark', {
              color: theme.palette.grey[800],
            }),
          })}
          size={50}
          thickness={4}
          {...props}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={(theme) => ({
            color: '#fece2f',
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
            ...theme.applyStyles('dark', {
              color: '#308fe8',
            }),
          })}
          size={50}
          thickness={4}
          {...props}
        />
      </Box>
    );
  }

  return (
    <div className="section-home light">

      <SeoHelmet
        title={pageTitle}
        description={TranslationsService.labels('textContactBanner')}
        schema={schema}
      />

      <div className="p-3 text-end box-locations-mobile">
      {
        TranslationsService.getGlobalValue('offices')?.map((offices, i) => ((
          <div key={i}>
            <h2 className="fs-4 fw-bold m-0 dark-mode-title">{offices.city}</h2>
            <p className="m-0">
              <a href={offices.google_maps ? offices.google_maps : undefined} target='_blank' rel="noreferrer" className='text-deco-none link-office-contact'>
                {offices.address}
              </a>
            </p>
            {
              offices.phone_number &&
              <p className="m-0">
                <a href={`tel:offices.phone_number`} className='text-deco-none link-office-contact m-0'> 
                  {`${offices.phone_number.substring(0, 3)} ${offices.phone_number.substring(3, 6)} ${offices.phone_number.substring(6, offices.phone_number.length)}`}
                </a>
              </p>
            }
          </div>
        )))
      }
      </div>

    <div className="d-flex align-items-center justify-content-between px-4 py-3" style={{ backgroundColor: '#FECE2F' }}>
      <span style={{ fontWeight: '600', fontSize: '1rem', color: '#090909' }}>
        {TranslationsService.labels('textContactBanner')}
      </span>
      <a
        href="mailto:info@sydea.com"
        style={{
          backgroundColor: '#090909',
          color: '#fff',
          fontWeight: '700',
          fontSize: '0.95rem',
          padding: '0.6rem 1.8rem',
          textDecoration: 'none',
          letterSpacing: '0.03em',
          whiteSpace: 'nowrap',
          marginLeft: '1.5rem',
        }}
      >
        {TranslationsService.labels('textButtonContactBanner')}
      </a>
    </div>
      
      <div className="position-relative map-locations">
        
        {
          appOwner === 'sydea' &&
          <>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 860" className='w-100 position-absolute'>
              <rect className="cls-1-map" width="1920" height="860"/>
              <circle className="cls-4-map" cx="1662.92" cy="508.81" r="5"/>
              <rect className="cls-3-map" x="1036.84" y="194.77" width="540.66" height="111.17"/>
              <text className="cls-8-map" transform="translate(1064.15 262.63)">
                <tspan className="cls-5-map">
                  <tspan x="0" y="0">
                    <a href={TranslationsService.getGlobalValue('offices')[0].google_maps ? TranslationsService.getGlobalValue('offices')[0].google_maps : undefined} target='_blank' rel="noreferrer" className='cls-3-map text-deco-none cls-5-map transition-03s-eio'>
                      {TranslationsService.getGlobalValue('offices')[0].address}
                    </a>
                  </tspan>
                </tspan>
                {
                  TranslationsService.getGlobalValue('offices')[0].phone_number &&
                  <tspan className="cls-6-map"><tspan x="0" y="24">
                    <a href={`tel:${TranslationsService.getGlobalValue('offices')[0].phone_number}`} className='text-deco-none transition-03s-eio'> 
                      {`${TranslationsService.getGlobalValue('offices')[0].phone_number.substring(0, 3)} ${TranslationsService.getGlobalValue('offices')[0].phone_number.substring(3, 6)} ${TranslationsService.getGlobalValue('offices')[0].phone_number.substring(6, TranslationsService.getGlobalValue('offices')[0].phone_number.length)}`}
                    </a>
                  </tspan>
                  </tspan>
                }
              </text>
              <text className="cls-7-map" transform="translate(1064.15 234.51)">
                <tspan x="0" y="0" className="text-uppercase">{TranslationsService.getGlobalValue('offices')[0].city}</tspan>
              </text>
              <rect className="cls-3-map" x="871.97" y="496.85" width="540.57" height="111.15"/>
              <polyline className="cls-2-map" points="871.97 496.85 1412.53 496.85 1700.79 566.65"/>
              <text className="cls-8-map" transform="translate(890.15 564.7)">
                <tspan className="cls-5-map">
                  <tspan x="0" y="0">
                    <a href={TranslationsService.getGlobalValue('offices')[1].google_maps ? TranslationsService.getGlobalValue('offices')[1].google_maps : undefined} target='_blank' rel="noreferrer" className='cls-3-map text-deco-none cls-5-map transition-03s-eio'>
                      {TranslationsService.getGlobalValue('offices')[1].address}
                    </a>
                  </tspan>
                </tspan>
                {
                  TranslationsService.getGlobalValue('offices')[1].phone_number &&
                  <tspan className="cls-6-map"><tspan x="0" y="24">
                    <a href={`tel:${TranslationsService.getGlobalValue('offices')[1].phone_number}`} className='text-deco-none transition-03s-eio'> 
                      {`${TranslationsService.getGlobalValue('offices')[1].phone_number.substring(0, 3)} ${TranslationsService.getGlobalValue('offices')[1].phone_number.substring(3, 6)} ${TranslationsService.getGlobalValue('offices')[1].phone_number.substring(6, TranslationsService.getGlobalValue('offices')[1].phone_number.length)}`}
                    </a>
                  </tspan>
                  </tspan>
                }
                </text>
                <text className="cls-7-map" transform="translate(890.15 536.57)">
                  <tspan x="0" y="0" className="text-uppercase">{TranslationsService.getGlobalValue('offices')[1].city}</tspan>
                </text>
                <circle className="cls-4-map" cx="1701.13" cy="566.82" r="5"/>
                <rect className="cls-3-map" x="1129.83" y="714.99" width="540.64" height="111.49"/>
                <polyline className="cls-2-map" points="1129.83 715.54 1670.48 715.54 1786.23 554.4"/>
                <text className="cls-8-map" transform="translate(1148.48 782.91)">
                  <tspan className="cls-5-map">
                    <tspan x="0" y="0">
                      <a href={TranslationsService.getGlobalValue('offices')[2].google_maps ? TranslationsService.getGlobalValue('offices')[2].google_maps : undefined} target='_blank' rel="noreferrer" className='cls-3-map text-deco-none cls-5-map transition-03s-eio'>
                        {TranslationsService.getGlobalValue('offices')[2].address}
                      </a>
                    </tspan>
                  </tspan>
                  {
                    TranslationsService.getGlobalValue('offices')[2].phone_number &&
                    <tspan className="cls-6-map"><tspan x="0" y="24">
                      <a href={`tel:${TranslationsService.getGlobalValue('offices')[2].phone_number}`} className='text-deco-none transition-03s-eio'> 
                        {`${TranslationsService.getGlobalValue('offices')[2].phone_number.substring(0, 3)} ${TranslationsService.getGlobalValue('offices')[2].phone_number.substring(3, 6)} ${TranslationsService.getGlobalValue('offices')[2].phone_number.substring(6, TranslationsService.getGlobalValue('offices')[2].phone_number.length)}`}
                      </a>
                    </tspan>
                    </tspan>
                  }
                </text>
                <text className="cls-7-map" transform="translate(1148.48 754.79)">
                  <tspan x="0" y="0" className="text-uppercase">{TranslationsService.getGlobalValue('offices')[2].city}</tspan>
                </text>
                <circle className="cls-4-map" cx="1786.23" cy="554.4" r="5"/>
                <polyline className="cls-2-map" points="1036.84 194.77 1577.49 194.77 1662.98 508.52"/>
                <rect className="cls-3-map" x="369.17" y="130.72" width="641" height="111.17"/>
                <text className="cls-8-map" transform="translate(396.48 198.58)">
                  <tspan className="cls-5-map">
                    <tspan x="0" y="0">
                    <a href={TranslationsService.getGlobalValue('offices')[3].google_maps ? TranslationsService.getGlobalValue('offices')[3].google_maps : undefined} target='_blank' rel="noreferrer" className='cls-3-map text-deco-none cls-5-map transition-03s-eio'>
                        {TranslationsService.getGlobalValue('offices')[3].address}
                      </a>
                    </tspan>
                  </tspan>
                  {
                    TranslationsService.getGlobalValue('offices')[3].phone_number &&
                    <tspan className="cls-6-map"><tspan x="0" y="24">
                      <a href={`tel:${TranslationsService.getGlobalValue('offices')[3].phone_number}`} className='text-deco-none transition-03s-eio'> 
                        {`${TranslationsService.getGlobalValue('offices')[3].phone_number.substring(0, 3)} ${TranslationsService.getGlobalValue('offices')[3].phone_number.substring(3, 6)} ${TranslationsService.getGlobalValue('offices')[3].phone_number.substring(6, TranslationsService.getGlobalValue('offices')[3].phone_number.length)}`}
                      </a>
                    </tspan>
                    </tspan>
                  }
                </text>
                <text className="cls-7-map" transform="translate(396.48 170.45)">
                  <tspan x="0" y="0" className="text-uppercase">{TranslationsService.getGlobalValue('offices')[3].city}</tspan>
                </text>
              <circle className="cls-4-map" cx="95.77" cy="345.39" r="5"/>
              <polyline className="cls-2-map" points="1010.23 130.72 369.17 130.72 95.83 345.1"/>
            </svg>
            <img
              src={require("../../assets/image/offices_map.png")}
              className="w-100"
              alt="Sydea Offices"
            ></img>
          </>
        }
      </div>

      {/* {
        TranslationsService.showContactFormMain() &&
        <div className="p-3">
        <div className="box-contact m-auto p-4">
          <h2 className="syd-title dark fw-bold py-3">
            {TranslationsService.labels(`menu.contact-us.label`)}
          </h2>
          <form onSubmit={handleSubmit} className="width-form" id="contact-form">
            <div className="my-3">
              <input
                required
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder={`${TranslationsService.labels('formName')}*`}
                className="w-100 p-3 input-contact"
                disabled={isLoading}
              />
            </div>
            <div className="my-3">
              <input
                required
                type="text"
                name="mailSubject"
                value={formData.mailSubject}
                onChange={handleChange}
                placeholder={`${TranslationsService.labels('formSubject')}*`}
                className="w-100 p-3 input-contact"
                disabled={isLoading}
              />
            </div>
            <div className="my-3">
              <input
                required
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={`${TranslationsService.labels('formMail')}*`}
                className="w-100 p-3 input-contact"
                disabled={isLoading}
              />
            </div>
            <div className="my-3">
              <textarea
                required
                name="bodyMail"
                value={formData.bodyMail}
                onChange={handleChange}
                rows={5}
                placeholder={TranslationsService.labels(`formComment`)}
                className="w-100 p-3 input-contact"
                disabled={isLoading}
              />
            </div>
            <label className="my-3 syd-checkbox-label">
              <input className="syd-checkbox" type="checkbox" required
                name="isChecked"
                checked={formData.isChecked}
                onChange={handleChange}
                disabled={isLoading}
              />
                {TranslationsService.labels(`textSubmitForm`)}
            </label>
            <div ref={widgetRef}></div>
            <button type="submit" className="syd-button m-0 mb-3 px-5" disabled={isLoading} style={{textTransform: 'inherit', borderRadius:0, fontWeight: 'bold', padding: '1rem 4rem !important', fontSize:'1.125rem'}}>
              {TranslationsService.labels(`buttonSubmitForm`)}
            </button>
          </form>

          {
            isLoading &&
            <div className='box-fixed-loader'>
              <CustomCircularProgress />
            </div>
          }

          <div className="position-fixed bottom-0 end-0 p-3" style={{zIndex:'11'}}>
            <div id="liveToast" className={`toast ${showToast} text-white bg-success`} role="alert" aria-live="assertive" aria-atomic="true">
              <div className="d-flex">
                <div className="toast-body" style={{fontSize:'18px'}}>
                  {TranslationsService.labels(`msg_toast_submit_form`)}
                </div>
                <button type="button" className="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      } */}
    </div>
  );
};
